// HTML-Only Fund Widget Class

const SELECTORS = {
    fund: '.js-fund',
    togglePanel: '.js-fund-togglepanel',
    toggleBtn: '.js-fund-togglebtn'
}

const CLASSES = {
    isOpen: 'is-open',
    withCriteria: 'fund--with-criteria'
}

class Fund {
    constructor(el) {
        this.fund = el
        this.toggleBtn = el.querySelector(SELECTORS.toggleBtn)
        this.togglePanel = el.querySelector(SELECTORS.togglePanel)

        this.isOpen = false

        this.bindEvents()
    }

    bindEvents() {
        this.toggleBtn.addEventListener('click', () =>
            this.toggleCriteriaPanel()
        )
    }

    toggleCriteriaPanel() {
        this.isOpen = !this.isOpen

        this.fund.classList.toggle(CLASSES.withCriteria)
        this.toggleBtn.setAttribute('aria-expanded', String(this.isOpen))

        if (this.isOpen) {
            this.togglePanel.removeAttribute('hidden')
        } else {
            this.togglePanel.setAttribute('hidden', true)
        }

        window.setTimeout(() => this.fund.classList.toggle(CLASSES.isOpen), 250)
    }
}

// Register All Funds
const allFunds = document.querySelectorAll(SELECTORS.fund)
Array.from(allFunds, el => new Fund(el))
